import React, { useEffect, useState } from 'react';
import { Capacitor } from '@capacitor/core';
import { useNavigate } from 'react-router-dom';
import {
  cartPathFromCheckoutExit,
  isCheckoutCancelUrl,
  openHostedCheckoutUrl,
  readMpgsPayLaunch,
  resetMpgsCheckoutScript,
} from '../utils/mpgsCheckout';

export default function MpgsPayPage() {
  const navigate = useNavigate();
  const launch = readMpgsPayLaunch();
  const checkoutUrl = String(launch?.checkoutUrl || '').trim();
  const [error, setError] = useState(
    checkoutUrl ? '' : 'Card payment did not open. Go back to Cart and tap Place Order again.'
  );

  const goBackToCart = (query = '') => {
    resetMpgsCheckoutScript();
    navigate(query ? `/cart${query}` : '/cart', { replace: true });
  };

  useEffect(() => {
    if (!checkoutUrl) return;
    let cancelled = false;

    void (async () => {
      try {
        const result = await openHostedCheckoutUrl(checkoutUrl);
        if (cancelled) return;
        if (!Capacitor.isNativePlatform()) return;
        if (result.status === 'cancel' || isCheckoutCancelUrl(result.url)) {
          goBackToCart('?mpgs_cancel=1');
          return;
        }
        navigate(cartPathFromCheckoutExit(result.url), { replace: true });
      } catch (err: any) {
        if (cancelled) return;
        setError(err?.message || 'Could not open card payment in the app.');
      }
    })();

    return () => {
      cancelled = true;
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [checkoutUrl]);

  return (
    <div className="min-h-screen bg-[#fff8f0] flex flex-col" style={{ touchAction: 'auto' }}>
      <div className="flex items-center justify-between gap-3 border-b border-amber-200 px-4 py-3">
        <div className="min-w-0">
          <p className="text-sm font-bold text-amber-950">Secure card payment</p>
          <p className="text-xs text-amber-800 truncate">
            {error || 'Opening NI card payment…'}
          </p>
        </div>
        <button
          type="button"
          onClick={() => goBackToCart()}
          className="shrink-0 rounded-lg bg-white px-3 py-2 text-sm font-semibold text-amber-900 border border-amber-300"
        >
          Cancel
        </button>
      </div>
      <div className="flex-1 flex flex-col items-center justify-center gap-4 px-6">
        {error ? (
          <p className="text-sm text-red-800 text-center">{error}</p>
        ) : (
          <p className="text-sm text-amber-900 text-center">Opening the card form…</p>
        )}
        {error && (
          <button
            type="button"
            onClick={() => goBackToCart()}
            className="rounded-lg bg-amber-800 px-4 py-3 text-sm font-semibold text-white"
          >
            Back to cart
          </button>
        )}
      </div>
    </div>
  );
}
